import Month from '@app/model/market_state/Month';
import MarketStateDailySnapshotWithComparisonOutput
	from '@app/model/market_state/output/MarketStateDailySnapshotWithComparisonOutput';
import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import PriceRecommendationStateSnapshot from '@app/model/market_state/output/PriceRecommendationStateSnapshot';

export default class MarketStateSnapshotOutput {
	companyHotelId: number;
	latestUpdateDate: string;
	latestUpdateDatePerMonth: {
		month: Month
		lastUpdateDate: string
	}[];
	latestRecommendationRunDate?: string | null;
	dailySnapshots: MarketStateDailySnapshotWithComparisonOutput[];

	constructor(data: MarketStateSnapshotOutput) {
		Object.assign(this, data);
		if (data.dailySnapshots) {
			this.dailySnapshots = data.dailySnapshots.map(item => new MarketStateDailySnapshotWithComparisonOutput(item));
		} else data.dailySnapshots = [];
	}

	public findDailySnapshot(statDate: string): MarketStateDailySnapshotWithComparisonOutput | undefined {
		return this.dailySnapshots.find(item => item.statDate === statDate);
	}

	public findPriceRecommendationState(statDate: string): PriceRecommendationStateSnapshot | undefined {
		const dailySnapshot = this.findDailySnapshot(statDate);
		if (!dailySnapshot) return undefined;
		return dailySnapshot.priceRecommendationStateSnapshot;
	}

	public hasPriceRecommendationStates() {
		return this.dailySnapshots.some(item => item.priceRecommendationStateSnapshot);
	}
}